import { useMutation, useQuery } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useTranslation } from 'react-i18next';
import posthog from 'posthog-js';
import { postForms } from '../requests';
import { PostFormsRequestType } from '../types';

export const useExtForms = (
  form: PostFormsRequestType['pathParams']['form'],
) => {
  const { i18n } = useTranslation();

  const query = useQuery({
    queryKey: [API_QUERY_KEYS.extForm, form],
    queryFn: () =>
      postForms({
        pathParams: { form },
        headers: {
          'x-app-locale': i18n.language,
        },
      }),
    onSuccess: () => {
      posthog.capture('FormLoaded', {
        accessCode: false,
      });
    },
  });

  const mutation = useMutation({
    mutationKey: [API_QUERY_KEYS.extForm, form],
    mutationFn: (accessCode?: string) =>
      postForms({
        pathParams: { form },
        body: { accessCode },
        headers: { 'x-app-locale': i18n.language },
      }),
    onSuccess: () => {
      posthog.capture('FormLoaded', {
        accessCode: true,
      });
    },
  });

  return {
    ...query,
    isLoading: query.isLoading || mutation.isLoading,
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: query.data?.data || mutation.data?.data,
    accessCodeRequired: query.error?.response?.status === 401,
  };
};
